

















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DecisionList from "@/apps/management/decision/DecisionList.vue";
import { useMegaraxClient } from "../shared/useMegaraxClient";
import { CurrentUser } from "@megarax/client/src/megaraxClient";

@Component({
  components: { DecisionList },
})
export default class HomePage extends Vue {
  get user(): CurrentUser {
    return useMegaraxClient().user!;
  }

  get userStanowiskaNames() {
    return this.user.groups!.map((g) => g.name).join(", ");
  }
}
